import axios, { AxiosError } from 'axios';
import { Environment } from '../../environment';
import { Api } from './axios-config';

export interface IListagemColheita {
  guuidcolheita: string;
  datalan: Date;
  nome: string;
  numero: number;
  fazenda: string;
  area: number;
  quadra: string;
  codverificador: string;
  qtd: number;
  valor: number;
  total: number;
  status: number;
}

export interface IDetalheCei {
  numero: string;
  produtor: string;
}

export interface ICeiList{
  codcei: number;
  nome: string;
}

type TotalCount = {
    data: IListagemColheita[];
    totalCount: number;
    totalQtd: number;
    vlrTotal: number;
}

interface IQuadras {
  quadra: string,
  quantidade: number;
}

interface IQuadrasColhedor {
  datalan: Date,
  quadra: string,
  quantidade: number;
}


interface IColhedor {
	nome: string;
  quantidade: number;
}

interface IFazendas {
	nome: string;
  quantidade: number;
}

interface IAreas {
  area: number;
  quantidade: number;
  quadras: IQuadras[]
}

interface IAreasColhedor {
  area: number;
  quantidade: number;
  quadras: IQuadrasColhedor[]
}


export interface IRcolheitas {
  fazenda: IFazendas
  areas: IAreas[];
}

export interface IRColheitasColhedor {
  colhedor: IColhedor;
  areas: IAreasColhedor[];
}

interface ErrorResponse {
  error: {
    default: string;
  };
}

const getAll = async (page = 1, tipo: string, filter: string, datainicial: string, datafinal: string): Promise<TotalCount | Error> => {
  try {
    const urlRelativa = `/colheitas?page=${page}&limit=${12}&tipo=${tipo}&filter=${filter}&datainicial=${datainicial}&datafinal=${datafinal}`;

    const { data, headers } = await Api.get(urlRelativa);
    if (data) {
      return {
        data,
        totalCount: Number(headers['x-total-count'] || 12),
        totalQtd: Number(headers['x-total-qtd'] || 0),
        vlrTotal: Number(headers['x-total-total'] || 0),
      };
    }
    return new Error('Erro ao listar os registros.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

const RColheitas = async (datainicial: string, datafinal: string): Promise<IRcolheitas[] | Error> => {
  try {
    const urlRelativa = `/rcolheitas?datainicial=${datainicial}&datafinal=${datafinal}`;

    const { data } = await Api.get(urlRelativa);
    if (data) {
      return data;
    }
    return new Error('Erro ao consultar o registro.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

const RColheitasPorColhedor = async (codfaz: number, datainicial: string, datafinal: string): Promise<IRColheitasColhedor[] | Error> => {
  try {
    const urlRelativa = `/rcolheitascolhedor?codfaz=${codfaz}&datainicial=${datainicial}&datafinal=${datafinal}`;

    const { data } = await Api.get(urlRelativa);
    if (data) {
      return data;
    }
    return new Error('Erro ao consultar o registro.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

const deleteById = async (id: string): Promise<void | Error> => {
  try {
    await Api.delete(`/colheitas/${id}`);
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.error?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};

export const ColheitasService = {
  getAll,
  deleteById,
  RColheitas,
  RColheitasPorColhedor,
};